import { useEffect, useState } from 'react';

interface MousePosition {
	x: number;
	y: number;
}

export function useMousePositionGlobal(): MousePosition {
	const [mousePosition, setMousePosition] = useState<MousePosition>({
		x: 0,
		y: 0,
	});

	useEffect(() => {
		const handleMouseMove = (event: MouseEvent) => {
			setMousePosition({ x: event.clientX, y: event.clientY });
		};
		window.addEventListener('mousemove', handleMouseMove);
		return () => window.removeEventListener('mousemove', handleMouseMove);
	}, []);

	return mousePosition;
}

export function useMousePosition(
	ref: React.RefObject<HTMLElement | null>,
	callback?: ({ x, y }: MousePosition) => void,
) {
	useEffect(() => {
		const handleMouseMove = (event: MouseEvent) => {
			const { clientX, clientY } = event;
			const { top, left } = ref.current?.getBoundingClientRect() || {
				top: 0,
				left: 0,
			};

			callback?.({ x: clientX - left, y: clientY - top });
		};

		const handleTouchMove = (event: TouchEvent) => {
			if (event?.touches && event.touches.length < 1) return;

			const { clientX, clientY } = event.touches[0];
			const { top, left } = ref.current?.getBoundingClientRect() || {
				top: 0,
				left: 0,
			};

			callback?.({ x: clientX - left, y: clientY - top });
		};

		ref.current?.addEventListener('mousemove', handleMouseMove);
		ref.current?.addEventListener('touchmove', handleTouchMove);

		const nodeRef = ref.current;
		return () => {
			nodeRef?.removeEventListener('mousemove', handleMouseMove);
			nodeRef?.removeEventListener('touchmove', handleTouchMove);
		};
	}, [ref, callback]);
}
